(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3982,65250],{

/***/ 3982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MoveMEoutWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/styles/variables/moveMEoutVariables.module.scss
var moveMEoutVariables_module = __webpack_require__(3007);
var moveMEoutVariables_module_default = /*#__PURE__*/__webpack_require__.n(moveMEoutVariables_module);
;// CONCATENATED MODULE: ./src/components/movemeout/logo/index.tsx


function MoveMEoutLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "234",
        height: "29",
        viewBox: "0 0 234 29",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M70.9349 8.92025C71.8073 8.86008 72.6814 9.01034 73.4837 9.35838C74.2859 9.70643 74.9928 10.2421 75.5449 10.9203C76.0741 11.6693 76.4432 12.5195 76.629 13.4177C76.8149 14.3158 76.8134 15.2427 76.6249 16.1403L75.1749 25.9303H72.1749L73.5649 16.5003C73.844 15.2871 73.6697 14.0138 73.0749 12.9203C72.7733 12.4966 72.3668 12.1587 71.8952 11.9395C71.4236 11.7204 70.9032 11.6276 70.3849 11.6703C69.749 11.663 69.1178 11.7811 68.5276 12.0179C67.9373 12.2547 67.3995 12.6055 66.9449 13.0503C65.9505 14.0198 65.3187 15.3011 65.1549 16.6803L63.7649 25.9303H60.8249L62.2149 16.5603C62.4965 15.3352 62.3148 14.0493 61.7049 12.9503C61.4059 12.5196 60.9993 12.1748 60.5256 11.9502C60.0519 11.7256 59.5275 11.6291 59.0049 11.6703C58.3583 11.6636 57.7172 11.7887 57.1206 12.038C56.524 12.2873 55.9845 12.6556 55.5349 13.1203C54.5037 14.2196 53.8548 15.6225 53.6849 17.1203L52.3549 25.9403H49.3549L51.9149 9.33025H54.7949L54.4549 11.7403C55.0514 10.8633 55.8536 10.1459 56.7915 9.65082C57.7294 9.15573 58.7744 8.89802 59.8349 8.90025C60.8938 8.87228 61.9374 9.15754 62.8349 9.72025C63.6661 10.2287 64.2952 11.0098 64.6149 11.9303C65.3183 10.9777 66.2503 10.2176 67.3249 9.72025C68.4507 9.17951 69.6861 8.90575 70.9349 8.92025Z",
                fill: "#00ADE6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M87.1449 26.3303C86.0293 26.3909 84.9151 26.1869 83.8933 25.7351C82.8714 25.2832 81.9708 24.5963 81.2649 23.7303C80.597 22.8425 80.1183 21.8271 79.8586 20.7469C79.5989 19.6667 79.5636 18.5447 79.7549 17.4503C80.0893 15.0875 81.2642 12.9244 83.0642 11.3577C84.8641 9.79096 87.1686 8.9256 89.5549 8.92028C90.6531 8.86002 91.7498 9.06162 92.7547 9.50845C93.7597 9.95528 94.644 10.6346 95.3349 11.4903C96.0273 12.3629 96.5218 13.3756 96.7842 14.4582C97.0467 15.5408 97.0708 16.6674 96.8549 17.7603C96.5492 20.1364 95.3821 22.3176 93.5749 23.8903C91.8221 25.4953 89.5213 26.3684 87.1449 26.3303ZM87.2649 23.6103C88.8897 23.6021 90.4497 22.9723 91.6249 21.8503C92.88 20.7511 93.6937 19.2339 93.9149 17.5803C94.0513 16.8524 94.0327 16.1039 93.8604 15.3837C93.6881 14.6635 93.3659 13.9876 92.9149 13.4003C92.4941 12.8357 91.9414 12.3828 91.3051 12.0812C90.6688 11.7796 89.9683 11.6385 89.2649 11.6703C87.6632 11.6765 86.1247 12.2955 84.9649 13.4003C83.7155 14.4874 82.9109 15.997 82.7049 17.6403C82.4424 19.121 82.7768 20.6454 83.6349 21.8803C84.052 22.4439 84.6011 22.8965 85.2341 23.1981C85.867 23.4998 86.5644 23.6413 87.2649 23.6103Z",
                fill: "#00ADE6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M105.635 21.7503L112.535 9.35026H115.785L106.005 25.9003H103.935L99.0749 9.33026H102.385L105.635 21.7503Z",
                fill: "#00ADE6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M125.075 8.95025C126.107 8.88567 127.141 9.0585 128.096 9.45547C129.051 9.85243 129.902 10.463 130.585 11.2403C131.244 12.1169 131.704 13.1265 131.934 14.1988C132.163 15.2712 132.157 16.3806 131.915 17.4503C131.815 18.0103 131.715 18.4503 131.635 18.8503H118.435C118.407 19.487 118.507 20.1229 118.728 20.7206C118.95 21.3182 119.289 21.8655 119.725 22.3303C120.219 22.786 120.802 23.1356 121.436 23.3574C122.071 23.5793 122.744 23.6688 123.415 23.6203C124.482 23.6029 125.541 23.4242 126.555 23.0903C127.593 22.7836 128.58 22.3253 129.485 21.7303L130.565 24.0503C129.509 24.7638 128.353 25.3165 127.135 25.6903C125.844 26.1147 124.494 26.334 123.135 26.3403C121.804 26.371 120.483 26.1081 119.265 25.5703C118.258 25.1219 117.395 24.4016 116.775 23.4903C116.206 22.6212 115.812 21.6498 115.615 20.6303C115.409 19.555 115.389 18.4524 115.555 17.3703C115.821 15.0476 116.944 12.9078 118.705 11.3703C120.442 9.78063 122.721 8.91491 125.075 8.95025ZM124.925 11.5803C123.563 11.5677 122.237 12.0191 121.165 12.8603C120.049 13.7474 119.238 14.9604 118.845 16.3303H129.075C129.167 15.7254 129.129 15.1081 128.966 14.5187C128.802 13.9293 128.515 13.3812 128.125 12.9103C127.723 12.4686 127.229 12.1206 126.678 11.8908C126.126 11.661 125.532 11.555 124.935 11.5803H124.925Z",
                fill: "#00ADE6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M138.945 25.9302H134.425L137.835 3.07025H140.835L147.835 16.0703L158.685 3.07025H161.775L158.375 25.9302H153.805L155.745 12.9302L147.675 22.4902H146.075L140.825 12.9302L138.945 25.9302Z",
                fill: "#F7921E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M178.965 25.9302H163.465L166.875 3.07025H182.365L181.715 7.33025H170.825L170.075 12.2603H180.155L179.545 16.5303H169.465L168.695 21.6603H179.585L178.965 25.9302Z",
                fill: "#F7921E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M190.535 26.3303C189.419 26.3909 188.305 26.1869 187.283 25.7351C186.261 25.2832 185.361 24.5963 184.655 23.7303C183.985 22.8433 183.505 21.8282 183.243 20.748C182.982 19.6677 182.945 18.5453 183.135 17.4503C183.47 15.0858 184.646 12.9214 186.448 11.3544C188.25 9.78748 190.557 8.9232 192.945 8.92028C194.043 8.86002 195.14 9.06162 196.145 9.50845C197.15 9.95528 198.034 10.6346 198.725 11.4903C199.417 12.3629 199.912 13.3756 200.174 14.4582C200.437 15.5408 200.461 16.6674 200.245 17.7603C199.935 20.1349 198.768 22.3147 196.965 23.8903C195.212 25.4945 192.911 26.3674 190.535 26.3303ZM190.655 23.6103C192.28 23.6021 193.84 22.9723 195.015 21.8503C196.27 20.7511 197.084 19.2339 197.305 17.5803C197.439 16.8523 197.419 16.1044 197.247 15.3846C197.075 14.6647 196.754 13.9888 196.305 13.4003C195.884 12.8357 195.331 12.3828 194.695 12.0812C194.059 11.7796 193.358 11.6385 192.655 11.6703C191.053 11.6765 189.515 12.2955 188.355 13.4003C187.098 14.4841 186.286 15.9942 186.075 17.6403C185.812 19.121 186.147 20.6454 187.005 21.8803C187.424 22.4468 187.976 22.9011 188.613 23.2029C189.25 23.5047 189.951 23.6446 190.655 23.6103Z",
                fill: "#00ADE6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M214.975 24.4003C213.468 25.7168 211.515 26.4073 209.515 26.3303C208.584 26.4018 207.649 26.2586 206.782 25.9119C205.915 25.5651 205.14 25.024 204.515 24.3303C203.415 22.9969 203.048 21.1636 203.415 18.8303L204.875 9.33026H207.805L206.355 18.9203C206.092 20.0934 206.304 21.323 206.945 22.3403C207.273 22.7559 207.698 23.0845 208.183 23.2972C208.667 23.51 209.197 23.6003 209.725 23.5603C210.338 23.5933 210.951 23.5013 211.526 23.2899C212.102 23.0784 212.629 22.7519 213.075 22.3303C214.012 21.3146 214.598 20.0243 214.745 18.6503L216.165 9.33026H219.165L217.715 18.8303C217.491 20.9531 216.52 22.9273 214.975 24.4003Z",
                fill: "#00ADE6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M233.075 11.8903H227.175L225.905 20.3303C225.555 22.5003 226.275 23.5803 228.045 23.5803C229.162 23.5156 230.245 23.1718 231.195 22.5803L232.035 24.9303C230.653 25.8539 229.027 26.3416 227.365 26.3303C226.657 26.4001 225.942 26.2879 225.29 26.0044C224.637 25.7209 224.067 25.2755 223.635 24.7103C222.85 23.2908 222.615 21.6319 222.975 20.0503L224.205 11.8903H221.305L221.705 9.35025H224.645L225.505 3.48026H228.445L227.545 9.35025H233.425L233.075 11.8903Z",
                fill: "#00ADE6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M35.4649 8.19026L33.8049 6.68026C33.7049 6.59026 33.6249 6.51026 33.6749 6.34026C34.0449 4.98026 34.4049 3.62026 34.7749 2.26026C34.8749 1.86026 34.9849 1.46026 35.0949 1.03026H34.8149H30.0749C30.0345 1.02313 29.993 1.02465 29.9533 1.03473C29.9135 1.04481 29.8763 1.06322 29.8442 1.08874C29.812 1.11426 29.7857 1.14631 29.7668 1.18278C29.748 1.21924 29.7371 1.25928 29.7349 1.30026C29.6249 1.75026 29.4949 2.19026 29.3649 2.67026L29.0949 2.44026C28.2449 1.66026 27.3849 0.90026 26.5449 0.11026C26.5122 0.0754492 26.4727 0.0477104 26.4288 0.0287476C26.385 0.00978472 26.3377 0 26.2899 0C26.2421 0 26.1949 0.00978472 26.151 0.0287476C26.1071 0.0477104 26.0676 0.0754492 26.0349 0.11026C24.2749 1.20026 22.5149 2.27026 20.7449 3.35026C19.3949 4.17026 18.0249 4.98026 16.7449 5.85026C15.5949 6.59026 14.4849 7.39026 13.3649 8.17026C13.1163 8.36191 12.8086 8.46092 12.4949 8.45026H8.27491C8.1063 8.43542 7.93702 8.4701 7.78782 8.55003C7.63861 8.62996 7.51597 8.75167 7.43491 8.90026C7.33602 9.0541 7.2812 9.23211 7.27643 9.41492C7.27166 9.59774 7.31711 9.77837 7.40784 9.93715C7.49858 10.0959 7.63112 10.2268 7.79105 10.3155C7.95098 10.4042 8.13217 10.4474 8.31492 10.4403H15.4549C15.592 10.4309 15.7295 10.4521 15.8575 10.5022C15.9854 10.5524 16.1006 10.6303 16.1949 10.7303C16.3214 10.8745 16.4037 11.052 16.4321 11.2418C16.4605 11.4315 16.4337 11.6254 16.3549 11.8003C16.2844 11.9769 16.1587 12.1259 15.9964 12.225C15.8342 12.3242 15.6442 12.3681 15.4549 12.3503C12.1749 12.3503 8.88491 12.3503 5.59491 12.3503H1.98491C1.77869 12.3315 1.57174 12.3772 1.39261 12.4811C1.21349 12.585 1.07103 12.7419 0.984914 12.9303C0.907597 13.0903 0.874342 13.2681 0.88857 13.4453C0.902797 13.6225 0.963996 13.7926 1.06586 13.9383C1.16773 14.084 1.30657 14.1999 1.46811 14.274C1.62965 14.3482 1.80804 14.378 1.98491 14.3603C4.82491 14.3603 7.67491 14.3603 10.5249 14.3603H13.5249C13.6866 14.351 13.8478 14.385 13.992 14.4588C14.1361 14.5327 14.258 14.6436 14.3449 14.7803C14.4327 14.9323 14.4789 15.1047 14.4789 15.2803C14.4789 15.4558 14.4327 15.6282 14.3449 15.7803C14.2673 15.9325 14.1457 16.0578 13.9959 16.1398C13.846 16.2219 13.6749 16.2569 13.5049 16.2403H6.81492C6.55126 16.2266 6.29288 16.3178 6.09618 16.4939C5.89948 16.67 5.7804 16.9167 5.76491 17.1803C5.75542 17.3124 5.77229 17.4452 5.81455 17.5708C5.85681 17.6964 5.9236 17.8123 6.01107 17.9119C6.09853 18.0115 6.20491 18.0926 6.32403 18.1507C6.44314 18.2088 6.57261 18.2426 6.70492 18.2503H17.8249C17.9519 18.2581 18.0758 18.2927 18.1884 18.3519C18.301 18.4111 18.3997 18.4935 18.4782 18.5937C18.5566 18.6939 18.6129 18.8095 18.6434 18.933C18.6738 19.0565 18.6778 19.1851 18.6549 19.3103C18.6272 19.55 18.5074 19.7695 18.3208 19.9225C18.1342 20.0755 17.8954 20.15 17.6549 20.1303H5.8349C5.2349 20.1303 4.63492 20.1303 4.03492 20.1303C3.80929 20.1404 3.59593 20.2359 3.4381 20.3974C3.28027 20.559 3.18976 20.7745 3.18491 21.0003C3.16689 21.1465 3.18142 21.2949 3.22744 21.4349C3.27346 21.5748 3.34984 21.7029 3.45112 21.8099C3.55239 21.9169 3.67607 22.0002 3.8133 22.0539C3.95052 22.1075 4.0979 22.1302 4.24491 22.1203H9.24491C9.24491 22.2403 9.24491 22.3203 9.24491 22.4103C9.17413 22.8453 9.23689 23.2916 9.42492 23.6903C9.58774 24.0371 9.84677 24.3299 10.1712 24.5337C10.4956 24.7376 10.8718 24.844 11.2549 24.8403C11.6849 24.8403 12.1149 24.8403 12.5649 24.8403C12.5649 24.9503 12.5649 25.0203 12.5649 25.1003C12.5301 25.5262 12.5301 25.9543 12.5649 26.3803C12.6818 26.9535 12.996 27.4675 13.4528 27.8329C13.9096 28.1984 14.4801 28.3921 15.0649 28.3803C16.0976 28.4323 17.1192 28.1474 17.976 27.5685C18.8327 26.9895 19.4781 26.1479 19.8149 25.1703C19.9549 24.7703 19.9049 24.8203 20.3249 24.8203H32.6249L36.0749 8.75026C35.8749 8.55026 35.6649 8.38026 35.4649 8.19026ZM15.7249 26.4703C15.5325 26.4964 15.3366 26.4734 15.1555 26.4033C14.9744 26.3333 14.814 26.2186 14.6892 26.0698C14.5644 25.9211 14.4793 25.7431 14.4418 25.5526C14.4044 25.3621 14.4157 25.1652 14.4749 24.9803C14.5754 24.4179 14.8899 23.9162 15.3523 23.5806C15.8146 23.245 16.389 23.1015 16.9549 23.1803C17.2162 23.2217 17.4532 23.3576 17.621 23.5622C17.7887 23.7668 17.8755 24.0259 17.8649 24.2903C17.8599 24.86 17.6341 25.4056 17.235 25.8122C16.8358 26.2189 16.2945 26.4547 15.7249 26.4703ZM21.5849 6.47026C21.6849 6.10026 21.6849 6.10026 22.0649 6.10026H24.1849C24.2949 6.10026 24.4349 6.10026 24.3749 6.28026C24.1649 7.06026 23.9549 7.84026 23.7549 8.62026C23.745 8.6823 23.7112 8.738 23.6607 8.77539C23.6103 8.81278 23.5471 8.8289 23.4849 8.82026H20.9649C21.1849 8.01026 21.3849 7.24026 21.5849 6.47026ZM22.6649 12.0103H20.0749C20.1649 11.6803 20.2449 11.3603 20.3249 11.0103C20.4649 10.5003 20.6049 10.0103 20.7349 9.49026C20.7349 9.36026 20.8149 9.26026 20.9749 9.27026H23.3549H23.5149C23.4449 9.55026 23.3749 9.82026 23.2949 10.0903C23.1549 10.6403 23.0049 11.1903 22.8549 11.7503C22.8649 11.9203 22.8149 12.0103 22.6649 12.0103ZM26.5249 10.1903C26.3749 10.7203 26.2349 11.2603 26.0949 11.8003C26.0874 11.8622 26.056 11.9188 26.0075 11.958C25.9589 11.9972 25.897 12.0159 25.8349 12.0103H23.3949H23.3049C23.4349 11.5403 23.5649 11.0703 23.6849 10.5903C23.8049 10.1103 23.8749 9.88026 23.9849 9.53026C23.9849 9.45026 24.1149 9.34026 24.1849 9.34026C25.0049 9.34026 25.8149 9.34026 26.6249 9.34026C26.6648 9.3358 26.705 9.3358 26.7449 9.34026C26.6649 9.62026 26.5949 9.90026 26.5249 10.1903ZM27.5249 6.36026C27.3249 7.10026 27.1249 7.84026 26.9349 8.58026C26.9349 8.73026 26.8349 8.82026 26.6649 8.81026H24.1349C24.2849 8.25026 24.4349 7.72026 24.5749 7.18026C24.6549 6.89026 24.7149 6.59026 24.8149 6.30026C24.8316 6.25375 24.8594 6.21207 24.8961 6.17892C24.9327 6.14577 24.977 6.12219 25.0249 6.11026H27.4649C27.4649 6.11026 27.5149 6.11026 27.5749 6.11026C27.6349 6.11026 27.5649 6.33026 27.5449 6.33026L27.5249 6.36026Z",
                fill: "#00ADE6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.5849 18.2002C3.74632 18.2145 3.90886 18.1913 4.0598 18.1323C4.21073 18.0733 4.34597 17.9802 4.45491 17.8602C4.57749 17.7016 4.65438 17.5125 4.67729 17.3134C4.7002 17.1142 4.66826 16.9126 4.5849 16.7302C4.50762 16.5565 4.37897 16.4107 4.21626 16.3124C4.05356 16.214 3.86463 16.1679 3.67491 16.1802C2.78491 16.1802 1.9049 16.1802 1.0249 16.1802C0.775894 16.1967 0.536644 16.2834 0.3349 16.4302C0.176996 16.5709 0.0677454 16.7579 0.0228268 16.9646C-0.0220918 17.1712 -0.000366308 17.3867 0.0848996 17.5802C0.154326 17.7659 0.2807 17.9249 0.445938 18.0345C0.611175 18.1441 0.806813 18.1986 1.0049 18.1902C1.4449 18.1902 1.88491 18.1902 2.32491 18.1902C2.74491 18.2002 3.1649 18.2102 3.5849 18.2002Z",
                fill: "#00ADE6"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.9549 23.1803C16.389 23.1015 15.8146 23.245 15.3522 23.5806C14.8899 23.9162 14.5754 24.4179 14.4749 24.9803C14.4157 25.1652 14.4043 25.3621 14.4418 25.5526C14.4793 25.7431 14.5644 25.9211 14.6892 26.0698C14.814 26.2186 14.9744 26.3333 15.1555 26.4033C15.3366 26.4734 15.5325 26.4964 15.7249 26.4703C16.2877 26.4551 16.8232 26.2248 17.2213 25.8267C17.6194 25.4286 17.8497 24.893 17.8649 24.3303C17.8858 24.0592 17.8037 23.7903 17.635 23.5771C17.4663 23.364 17.2235 23.2222 16.9549 23.1803Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M44.2049 18.0603C43.7749 17.3203 43.3249 16.5903 42.8849 15.8503C42.6149 15.4003 42.3449 14.9403 42.0649 14.4903C41.6049 13.7203 41.1449 12.9603 40.6949 12.1903C40.6293 12.0339 40.5151 11.9029 40.3692 11.8164C40.2234 11.73 40.0536 11.6928 39.8849 11.7103C39.1149 11.7103 38.3449 11.7103 37.5649 11.7103C37.2199 11.7041 36.8785 11.7819 36.5701 11.937C36.2618 12.092 35.9958 12.3196 35.7949 12.6003C35.7349 12.6803 35.6849 12.7703 35.6349 12.8503L32.9449 24.7703H33.8349C34.0049 24.7703 34.0949 24.7703 34.0549 25.0203C34.0149 25.2703 34.0549 25.2803 34.0549 25.4203C34.0147 25.8846 34.0762 26.3521 34.2349 26.7903C34.4464 27.3195 34.8401 27.7557 35.3449 28.0203C36.0648 28.4088 36.9075 28.502 37.6949 28.2803C38.4939 28.0954 39.2361 27.7195 39.8579 27.1848C40.4797 26.6501 40.9625 25.9726 41.2649 25.2103C41.3749 24.9503 41.4749 24.7103 41.8349 24.7303C41.9913 24.7198 42.1441 24.679 42.2849 24.6103C42.6307 24.4921 42.9375 24.2813 43.172 24.001C43.4065 23.7207 43.5596 23.3815 43.6149 23.0203C43.7449 22.1703 43.8749 21.3203 44.0149 20.4703C44.1149 19.7803 44.2249 19.0903 44.3149 18.4003C44.3179 18.2777 44.2791 18.1578 44.2049 18.0603ZM39.3849 24.7003C39.319 25.0053 39.1932 25.2942 39.0149 25.5503C38.8257 25.7955 38.5875 25.9986 38.3155 26.1467C38.0434 26.2947 37.7435 26.3845 37.4349 26.4103C37.2398 26.4494 37.0379 26.438 36.8483 26.3774C36.6588 26.3167 36.4878 26.2087 36.3517 26.0635C36.2155 25.9183 36.1186 25.7408 36.0702 25.5478C36.0218 25.3547 36.0234 25.1525 36.0749 24.9603C36.1236 24.6596 36.2346 24.3723 36.4006 24.1169C36.5666 23.8615 36.7841 23.6436 37.0392 23.477C37.2942 23.3104 37.5812 23.1989 37.8818 23.1495C38.1824 23.1001 38.49 23.114 38.7849 23.1903C39.0484 23.3292 39.2537 23.5576 39.3637 23.8345C39.4737 24.1113 39.4812 24.4184 39.3849 24.7003ZM41.3849 17.2103C41.1988 17.19 41.0119 17.2419 40.8631 17.3555C40.7142 17.469 40.6146 17.6354 40.5849 17.8203C40.4249 18.3303 40.5849 18.2903 39.9649 18.2903H37.3749C37.1684 18.3046 36.9618 18.263 36.777 18.1697C36.5922 18.0764 36.436 17.9349 36.3249 17.7603C36.242 17.6312 36.1868 17.4864 36.1627 17.3349C36.1386 17.1835 36.1462 17.0287 36.1849 16.8803C36.3049 16.3403 36.4549 15.8103 36.5949 15.2703C36.7349 14.7303 36.9049 14.0903 37.0549 13.5003C37.0598 13.4519 37.0744 13.4051 37.0979 13.3625C37.1214 13.32 37.1533 13.2826 37.1916 13.2527C37.2299 13.2228 37.2739 13.201 37.3208 13.1885C37.3678 13.1761 37.4168 13.1733 37.4649 13.1803H39.2149C39.297 13.174 39.379 13.1926 39.4503 13.2337C39.5217 13.2747 39.579 13.3362 39.6149 13.4103L41.1449 15.9503L41.7649 16.9503C41.7649 17.0103 41.8149 17.0803 41.8649 17.1903L41.3849 17.2103Z",
                fill: "url(#paint0_linear_2_389)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                    id: "paint0_linear_2_389",
                    x1: "30.5749",
                    y1: "25.3403",
                    x2: "46.4449",
                    y2: "13.3003",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            stopColor: "#F57E20"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                            offset: "0.69",
                            stopColor: "#FCAF17"
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/moveMEoutWrapper.tsx









const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function MoveMEoutWrapper({ children  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Moving",
                    domain: "moveMEout.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Moving",
                    domain: "moveMEout.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "Top Rated Moving Company",
                        textColor: (moveMEoutVariables_module_default()).offerCallNumber,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoveMEoutLogo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 3007:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progressColor":"#aaa","primaryColor":"#00ade6","lightPrimaryColor":"#dff5f9","green":"#5bc1a4","whyUsTitle":"#2e2e2e","whyUsItemTitle":"#00ade6","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","offerCallNumber":"#00ade6"};

/***/ })

}]);